import { Box, Stack, Typography } from '@mui/material';
import { selectOwnedNftId, selectOwnedPackage } from 'entities/mine-package/model';
import { COLOR_BG_SECONDARY, useShallowSelector } from 'shared';

import { AddToWalletButton, SuccessViewBase } from './ui';

export const OwnedNftSuccess = () => {
  const ownedPackageNft = useShallowSelector(selectOwnedPackage);
  const nftId = useShallowSelector(selectOwnedNftId);

  return (
    <SuccessViewBase
      title="🎉 You already own Mining Rig"
      subtitle="Pre-sale claim NFT was transferred to your wallet!"
      tap2minePackage={ownedPackageNft}
    >
      {nftId !== null && <AddToWalletButton tokenId={nftId} sx={{ mb: 2 }} />}

      <Stack
        bgcolor={COLOR_BG_SECONDARY}
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="center"
        borderRadius={3}
        gap={0.5}
        p={2}
        mb={1}
      >
        <Typography variant="h5" textTransform="capitalize" className="primary">
          {ownedPackageNft?.name}
        </Typography>

        <Box
          component="img"
          alt={`img-${ownedPackageNft?.name}`}
          src={ownedPackageNft?.image ?? ''}
          width={35}
          height={35}
        />
      </Stack>
    </SuccessViewBase>
  );
};
